import {
  LOGIN,
  REGISTER,
  GET_PROFILE,
  SEND_CONTACT,
  SEARCH_TAB,
} from "./../../actions/globalActions";
import { FETCH_LATEST_TABS } from "./../../actions/homeActions";
import {
  TAB_SUBMIT,
  GET_MY_TABS,
  GET_TAB,
  GET_ARTIST_TABS,
  GET_ARTIST_BY_LETTER,
} from "./../../actions/tabActions";
import processResponse from "./../util/processResponse";

const fetchMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case LOGIN:
      let postParams = {};
      postParams.email = action.user;
      postParams.password = action.pass;
      fetch(action.url, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(postParams),
      }).then((response) => {
        processResponse(response).then((data) => {
          if (response.status === 422) {
            action.errors = data;
            action.data = null;
          } else {
            action.errors = null;
            action.data = data;
          }
          next(action);
        });
      });
      break;

    case REGISTER:
      let registerPostParams = {};
      registerPostParams.name = action.data.name;
      registerPostParams.email = action.data.user;
      registerPostParams.password = action.data.pass;
      registerPostParams.password_confirmation = action.data.pass2;
      registerPostParams.recaptchaResponse = action.data.recaptchaResponse;
      registerPostParams.agree = action.data.agree;
      fetch(action.url, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(registerPostParams),
      }).then((response) => {
        processResponse(response).then((data) => {
          if (response.status === 422) {
            action.errors = data;
            action.data = null;
          } else {
            action.errors = null;
            action.data = data;
          }
          next(action);
        });
      });
      break;

    case SEND_CONTACT:
      let contactPostParams = {};
      contactPostParams.name = action.data.name;
      contactPostParams.email = action.data.email;
      contactPostParams.message = action.data.message;
      contactPostParams.recaptchaResponse = action.data.recaptchaResponse;
      fetch(action.url, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(contactPostParams),
      }).then((response) => {
        processResponse(response).then((data) => {
          if (response.status === 422) {
            action.errors = data;
            action.data = null;
          } else {
            action.errors = null;
            action.data = data;
          }
          next(action);
        });
      });
      break;

    case TAB_SUBMIT:
      let tabSubmitPostParams = {};
      tabSubmitPostParams.title = action.data.title;
      tabSubmitPostParams.artist = action.data.artist;
      tabSubmitPostParams.body = action.data.body;
      tabSubmitPostParams.bodyRendered = action.data.bodyRendered;

      fetch(action.url + "?token=" + localStorage.getItem("token"), {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(tabSubmitPostParams),
      }).then((response) => {
        processResponse(response).then((data) => {
          if (response.status === 422) {
            action.errors = data;
            action.data = null;
          } else {
            action.errors = null;
            action.data = data;
          }
          next(action);
        });
      });
      break;

    case GET_PROFILE:
      fetch(action.url + "?token=" + localStorage.getItem("token"), {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case SEARCH_TAB:
      fetch(action.url + "?term=" + action.term, {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case GET_TAB:
      fetch(action.url + "/" + action.id, {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case GET_ARTIST_TABS:
      fetch(action.url + "/" + action.slug, {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case GET_ARTIST_BY_LETTER:
      fetch(action.url + "/" + action.letter, {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case GET_MY_TABS:
      fetch(action.url + "?token=" + localStorage.getItem("token"), {
        headers: { "Content-Type": "application/json" },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          action.data = data;
          next(action);
        });
      });
      break;

    case FETCH_LATEST_TABS:
      fetch(action.url, {
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        method: "GET",
      }).then((response) => {
        processResponse(response).then((data) => {
          if (response.status === 422) {
            action.errors = data;
            action.data = null;
          } else {
            action.errors = null;
            action.data = data;
          }
          next(action);
        });
      });
      break;

    default:
      next(action);
  }
};

export default fetchMiddleware;



// WEBPACK FOOTER //
// ./src/reducers/middlewares/fetchMiddleware.js